import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, Row, Col } from 'antd';
import { CollapseExpandIcon } from '../../../custom_shared/components';
import { GeneralInformationNodeModel } from '../../models';
import {
    WorksheetTitleInput,
    WorksheetStatusInput,
    BookingYearInput,
    BookingPeriodInput
} from '../../node_inputs/GeneralInformationNodeInputs';
import { InputRenderer } from '../../components';
import { StyleUtils } from '../../misc';
import './GeneralInformationNodeRenderer.less';

interface Props {
    node: GeneralInformationNodeModel;
    addNodeRef: (nodeId: string, nodeRef: React.RefObject<HTMLDivElement>) => void;
}

const GeneralInformationNodeRenderer: React.FC<Props> = ({ node, addNodeRef }) => {
    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (containerRef.current) {
            addNodeRef(node.id, containerRef);
        }
    }, [addNodeRef, node.id]);

    return (
        <div ref={containerRef} className="general-information-node-renderer-container">
            <Collapse
                activeKey={node.expanded ? [node.id] : []}
                onChange={node.toggleExpanded}
                bordered={false}
                expandIcon={CollapseExpandIcon}
            >
                <Collapse.Panel
                    className="general-information-collapse-panel"
                    header={<span className="header-title">{node.name}</span>}
                    key={node.id}
                >
                    <Row gutter={10}>
                        <Col style={StyleUtils.getNodeColumnStyle(16)}>
                            <InputRenderer input={node.worksheetTitleInput} component={WorksheetTitleInput} />
                        </Col>
                    </Row>

                    <Row gutter={10}>
                        <Col style={StyleUtils.getNodeColumnStyle(8)}>
                            <InputRenderer input={node.bookingPeriodInput} component={BookingPeriodInput} />
                        </Col>

                        <Col style={StyleUtils.getNodeColumnStyle(8)}>
                            <InputRenderer input={node.bookingYearInput} component={BookingYearInput} />
                        </Col>

                        <Col style={StyleUtils.getNodeColumnStyle(8)}>
                            <InputRenderer input={node.worksheetStatusInput} component={WorksheetStatusInput} />
                        </Col>
                    </Row>
                </Collapse.Panel>
            </Collapse>
        </div>
    );
};

export default observer(GeneralInformationNodeRenderer);
